import { useSyncExternalStore } from 'react'
import { pubSubTimer } from '../../state/pubSub'
import {
    THROTTLE_TIMERS,
    TimerEvent,
    registerSnapTimer,
    type SnapSize,
} from '../../state/state.timers'

const subSnap = (id: number) => (callback: () => void) =>
    pubSubTimer.on(`${TimerEvent.STATE}::${id}`, callback)
const getSnapUrl = (id: number) => () =>
    THROTTLE_TIMERS.snaps[id.toString()]?.srcUrl

export const useSnaps = (id: number, size: SnapSize) => {
    const subbed = THROTTLE_TIMERS.snaps[id.toString()]?.srcUrl
    // console.log('[useSnaps]', id, idToSlug[id], { size, subbed })
    const regSrc = subbed ?? registerSnapTimer(id, size)
    const src = useSyncExternalStore(
        subSnap(id),
        getSnapUrl(id),
        getSnapUrl(id),
    )
    return src || regSrc
}
